export default function cleanObject(obj = {}) {
  const result = {}
  Object.keys(obj).forEach(key => {
    if (obj[key]) {
      result[key] = obj[key]
    }
  })
  return result
}
